export const navigationItems = [
    { name: 'home', path: '/', ar: 'الرئيسية', en: 'Home' },
    { name: 'about', path: '/about', ar: 'من نحن', en: 'About Us' },
    { name: 'faq', path: '/faq', ar: 'الأسئلة الشائعة', en: 'Frequently Asked Questions' },
    { name: 'contact', path: '/contact', ar: 'تواصل معنا', en: 'Contact Us' },
    { name: 'vision', path: '/vision', ar: 'رؤيتنا', en: 'Company Vision' },
];
